module.exports = __webpack_public_path__ + "img/cgq_ico.73a456e1.png";